import { ExternalAppId, M365AppId } from "../data/M365AppId";
import isConsumer from "owa-session-store/lib/utils/isConsumer";
import type { MailboxInfo } from "owa-client-types";

export default function getBizChatAppId(mailboxInfo: MailboxInfo): M365AppId {
    return isConsumer(undefined, mailboxInfo)
        ? ExternalAppId.ConsumerBizChat
        : M365AppId.CommercialBizChat;
}
